export const productReviews: Record<number, Array<{
  id: number;
  userName: string;
  rating: number;
  date: string;
  comment: string;
  verified: boolean;
}>> = {
  // Electronics
  7: [
    { id: 1, userName: 'Sarah M.', rating: 5, date: '2024-01-15', comment: 'Absolutely love this phone! The camera quality is incredible and the battery lasts all day.', verified: true },
    { id: 2, userName: 'Mike T.', rating: 5, date: '2024-01-10', comment: 'Best smartphone I\'ve ever owned. The titanium design feels premium.', verified: true },
    { id: 3, userName: 'Emily R.', rating: 4, date: '2024-01-05', comment: 'Great phone, but a bit pricey. Worth it for the features though!', verified: true },
  ],
  159: [
    { id: 1, userName: 'Jessica L.', rating: 5, date: '2024-01-20', comment: 'These earbuds are amazing! Sound quality is crystal clear and they fit perfectly.', verified: true },
    { id: 2, userName: 'David K.', rating: 5, date: '2024-01-18', comment: 'Best budget earbuds on the market. Noise cancellation works great!', verified: true },
    { id: 3, userName: 'Amanda P.', rating: 4, date: '2024-01-12', comment: 'Good value for money. Battery life could be better but overall satisfied.', verified: true },
  ],
  160: [
    { id: 1, userName: 'Chris B.', rating: 5, date: '2024-01-22', comment: 'Perfect phone case! Holds my cards securely and protects my phone well.', verified: true },
    { id: 2, userName: 'Lisa W.', rating: 5, date: '2024-01-19', comment: 'Love the slim design. No more carrying a wallet!', verified: true },
  ],
  
  // Fashion
  11: [
    { id: 1, userName: 'Olivia S.', rating: 5, date: '2024-01-16', comment: 'This handbag is absolutely stunning! The leather quality is exceptional.', verified: true },
    { id: 2, userName: 'Rachel M.', rating: 5, date: '2024-01-14', comment: 'Worth every penny. Gets compliments everywhere I go!', verified: true },
  ],
  163: [
    { id: 1, userName: 'Tom H.', rating: 5, date: '2024-01-21', comment: 'Simple, elegant, and affordable. Perfect everyday watch!', verified: true },
    { id: 2, userName: 'Alex J.', rating: 4, date: '2024-01-17', comment: 'Great minimalist design. Keeps accurate time.', verified: true },
  ],
  
  // Travel
  19: [
    { id: 1, userName: 'Jennifer K.', rating: 5, date: '2024-01-13', comment: 'Best vacation ever! Everything was perfectly organized and the hotels were luxurious.', verified: true },
    { id: 2, userName: 'Robert L.', rating: 5, date: '2024-01-08', comment: 'Incredible experience. Our guide was knowledgeable and friendly.', verified: true },
  ],
  
  // Gourmet
  23: [
    { id: 1, userName: 'Coffee Lover', rating: 5, date: '2024-01-20', comment: 'The best coffee subscription! Every month brings new amazing flavors.', verified: true },
    { id: 2, userName: 'Mark D.', rating: 5, date: '2024-01-15', comment: 'High quality beans, always fresh. Worth the subscription!', verified: true },
  ],
  
  // Home & Living
  161: [
    { id: 1, userName: 'Katie M.', rating: 5, date: '2024-01-19', comment: 'These LED lights transformed my room! Easy to install and great colors.', verified: true },
    { id: 2, userName: 'Brian S.', rating: 5, date: '2024-01-16', comment: 'Perfect for creating ambiance. Remote control is very convenient.', verified: true },
  ],
  174: [
    { id: 1, userName: 'Nicole P.', rating: 5, date: '2024-01-18', comment: 'Love this desk organizer! Keeps everything neat and tidy.', verified: true },
    { id: 2, userName: 'James R.', rating: 4, date: '2024-01-14', comment: 'Good quality bamboo. Looks great on my desk.', verified: true },
  ],
  
  // Health & Fitness
  15: [
    { id: 1, userName: 'Fitness Fan', rating: 5, date: '2024-01-17', comment: 'This treadmill is amazing! The interactive classes keep me motivated.', verified: true },
    { id: 2, userName: 'Steve M.', rating: 5, date: '2024-01-12', comment: 'Best investment for home fitness. Sturdy and feature-rich.', verified: true },
  ],
  171: [
    { id: 1, userName: 'Yoga Enthusiast', rating: 5, date: '2024-01-20', comment: 'Great resistance bands! Perfect for home workouts.', verified: true },
    { id: 2, userName: 'Michelle T.', rating: 5, date: '2024-01-15', comment: 'Excellent quality and variety of resistance levels.', verified: true },
  ],
};

export const getProductReviews = (productId: number) => {
  return productReviews[productId] || [];
};

export const getAverageRating = (productId: number) => {
  const reviews = productReviews[productId] || [];
  if (reviews.length === 0) return 0;
  const sum = reviews.reduce((acc, review) => acc + review.rating, 0);
  return (sum / reviews.length).toFixed(1);
};

export const getReviewCount = (productId: number) => {
  return (productReviews[productId] || []).length;
};
